import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const Bar = ({ width = "w-3/4", height = "h-4", className }) => (
  <div
    data-testid="skeleton-bar"
    className={classNames(
      "animate-pulse rounded-full bg-gray-200",
      width,
      height,
      className
    )}
  />
)

Bar.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

const Circle = ({ size = "h-8 w-8", className }) => (
  <div
    data-testid="skeleton-circle"
    className={classNames(
      "animate-pulse rounded-full bg-gray-200",
      size,
      className
    )}
  />
)

Circle.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
}

const Block = ({ width = "w-full", height = "h-10", className }) => (
  <div
    data-testid="skeleton-block"
    className={classNames(
      "animate-pulse rounded bg-gray-200",
      width,
      height,
      className
    )}
  />
)

Block.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

const Skeleton = { Bar, Circle, Block }

export default Skeleton
